import { API_ENDPOINTS, withParams } from '../config/apis';
import { apiRequest } from '../api/client';

/** 구간 — 백엔드 SplitResponse */
export type Split = {
  id: number;
  categoryId: number;
  /** 종료지점(타이밍포인트) id */
  timingPointId: number;
  splitName: string;
  splitDistance: number;
  totalDistance: number;
  /** 시간제한 최소 '-?HH:mm:ss' (소요시간). null = 제한 없음 */
  minTime: string | null;
  /** 시간제한 최대 '-?HH:mm:ss' (소요시간). null = 제한 없음 */
  maxTime: string | null;
};

export type SplitCreateBody = {
  categoryId: number;
  timingPointId: number;
  splitName: string;
  splitDistance: number;
  totalDistance: number;
  /** null = 제한 없음 */
  minTime: string | null;
  maxTime: string | null;
};

/** 수정 본문 — 종목(category)은 변경 불가라 제외 */
export type SplitUpdateBody = Omit<SplitCreateBody, 'categoryId'>;

export const splitService = {
  list: (eventId: number, categoryId: number) =>
    apiRequest<{ splits: Split[] }>(
      withParams(API_ENDPOINTS.splitList, { eventId }),
      { query: { categoryId } }
    ).then((res) => res.splits),

  create: (eventId: number, body: SplitCreateBody) =>
    apiRequest<Split>(withParams(API_ENDPOINTS.splitCreate, { eventId }), { body }),

  update: (eventId: number, splitId: number, body: SplitUpdateBody) =>
    apiRequest<Split>(withParams(API_ENDPOINTS.splitUpdate, { eventId, splitId }), { body }),

  delete: (eventId: number, splitId: number) =>
    apiRequest<void>(withParams(API_ENDPOINTS.splitDelete, { eventId, splitId })),
};
